import * as _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { Timestamp } from "firebase/firestore";
/*

datas armazenadas em unixtimestamp em miliseconds
Keys proibidas:
__fcmMockup.*
__fcmMockupDate

TODO:
  onSnapshot
  aggregate
  count
  batch
  update com paths
  query com or
  transactions

TODO:
  Não é detectado o limite de 30 cláusulas

armazena os dados por chave valor a partir da collection
dataObj: {
  events: {
    'dhskjdfsdjf': {
      doc: {
        dtProcedure: {
          __fcmMockupDate: {
            value: 1322323
          }
        }
      }
    }
  }
}

dataArray: {
  events: [
    {
      id: 'dhskjdfsdjf',
      doc: {
        active: true,
        patientName: 'João'
      }
    }
  ]
}

indexes: { // Ainda não usado
  events: {
    id: [ev1, ev2],
    dtProcedure: [ev2, ev1],
    active__dtProcedure: [ev2, ev1],
  }
}

 */
export function prepareDocToSaveRecursive(obj, op, maxDeep = 10, path = '') {
    if (maxDeep <= 0) {
        console.warn('prepareDocToSaveRecursive atingiu o número máximo de profundidade');
        return;
    }
    for (const k in obj) {
        if (obj[k] === undefined) {
            console.error('undefined not allow, find at: ' + path + '.' + k, obj);
            throw new Error('undefined not allow, find at: ' + path + '.' + k);
        }
        else if (typeof obj[k] === 'object') {
            if (k.includes('.')) {
                if (op === 'update') {
                    console.log('TODO update paths');
                }
            }
            if (obj[k] instanceof Date) {
                obj[k] = {
                    __fcmMockupDate: {
                        value: obj[k].valueOf(),
                    }
                };
            }
            // else if (obj[k] instanceof Timestamp) {
            else if (typeof obj[k]?.toMillis === 'function') {
                obj[k] = {
                    __fcmMockupDate: {
                        value: obj[k].toMillis(),
                    }
                };
            }
            else if (obj[k]?._methodName === 'serverTimestamp') {
                obj[k] = {
                    __fcmMockupDate: {
                        value: (new Date()).valueOf(),
                    }
                };
            }
            else {
                prepareDocToSaveRecursive(obj[k], op, maxDeep - 1, path + '.' + k);
            }
        }
    }
    return obj;
}
export function prepareDocToReturnRecursive(obj, maxDeep = 10, path = '') {
    if (maxDeep <= 0) {
        console.warn('prepareDocToSaveRecursive atingiu o número máximo de profundidade');
        return;
    }
    for (const k in obj) {
        if (typeof obj[k] === 'object') {
            if (obj[k]?.__fcmMockupDate) {
                obj[k] = Timestamp.fromMillis(obj[k].__fcmMockupDate.value);
            }
            else {
                prepareDocToReturnRecursive(obj[k], maxDeep - 1, path + '.' + k);
            }
        }
    }
    return obj;
}
class DocumentSnapshot {
    _value = null;
    id;
    ref;
    constructor(item, ref) {
        this._value = structuredClone(item.doc);
        prepareDocToReturnRecursive(this._value);
        this.id = item.id;
        this.ref = ref;
    }
    data() {
        return this._value;
    }
    exists() {
        return !!this._value;
    }
}
class QuerySnapshot {
    docs = [];
    _collection = '';
    _fcmFirestoreMockup;
    constructor(docs, collection, fcmFirestoreMockup) {
        this._fcmFirestoreMockup = fcmFirestoreMockup;
        this._collection = collection;
        this.docs = docs.map((a) => new DocumentSnapshot(a, this._fcmFirestoreMockup._getRef({ collection: this._collection, id: a.id })));
    }
    forEach(callback, thisArg) {
        this.docs.forEach(callback, thisArg);
    }
    get size() {
        return this.docs.length;
    }
    get empty() {
        return this.docs.length === 0;
    }
}
export class FcmFirestoreMockup {
    // O banco em si
    dataObj = {};
    dataArray = {};
    indexes = {};
    firestore;
    constructor(firestore) {
        this.firestore = firestore;
    }
    _getPath(ref) {
        const [collection, id] = ref.path.split('/');
        return { collection, id };
    }
    _setDoc(path, newValue, oldItem, op) {
        prepareDocToSaveRecursive(newValue, op);
        if (oldItem) {
            this.dataObj[path.collection][path.id].doc = newValue;
        }
        else {
            const item = {
                doc: newValue,
                id: path.id
            };
            this.dataObj[path.collection][path.id] = item;
            this.dataArray[path.collection].push(item);
        }
    }
    // loadAllJson(dataArray:any) {
    //   for (const collection in dataArray) {
    //     this.loadCollection(collection, dataArray[collection]);
    //   }
    // }
    //
    // loadCollection(collection: string, array:any) {
    //
    // }
    dump() {
        return this.dataArray;
    }
    dumpString() {
        return JSON.stringify(this.dataArray);
    }
    restoreDump(dataArray) {
        if (typeof dataArray === 'string') {
            dataArray = JSON.parse(dataArray);
        }
        this.dataArray = dataArray;
        for (const collection in dataArray) {
            this.dataObj[collection] ||= {};
            for (const item of dataArray[collection]) {
                this.dataObj[collection][item.id] = item;
            }
        }
    }
    _newId() {
        return uuidv4();
    }
    _getRef({ collection, id }) {
        return this.firestore.collection(collection).doc(id);
    }
    async getDocs(query) {
        console.log('query', query);
        const collection = query._query.path.segments[0];
        let dataCollection = (this.dataArray[collection] || []).slice();
        const orderByParams = [];
        let dir = '';
        for (const orderByIndex in query._query.explicitOrderBy || []) {
            const orderBy = query._query.explicitOrderBy[orderByIndex];
            if (dir && dir !== orderBy.dir) {
                console.error('O FcmFirestoreMockup não suporta ordenação misturada');
                throw new Error('O FcmFirestoreMockup não suporta ordenação misturada');
            }
            dir = orderBy.dir;
            orderByParams.push(orderBy.field.segments.join('.'));
            const startAt = query._query.startAt?.position?.[orderByIndex];
            if (startAt) {
                query._query.filters.push({
                    field: orderBy.field,
                    op: query._query.startAt.inclusive ? '>=' : '>',
                    value: startAt
                });
            }
            const endAt = query._query.endAt?.position?.[orderByIndex];
            if (endAt) {
                query._query.filters.push({
                    field: orderBy.field,
                    op: query._query.endAt.inclusive ? '<=' : '<',
                    value: startAt
                });
            }
        }
        if (orderByParams.length) {
            dataCollection = _.sortBy(dataCollection, orderByParams);
        }
        if (dir === 'desc') {
            dataCollection.reverse();
        }
        if (query._query.filters?.length) {
            for (const filter of query._query.filters || []) {
                const key = Object.keys(filter.value)[0];
                filter._fcmValue = filter.value[key];
                filter._fcmPath = filter.field.segments.join('.');
                if (key === 'timestampValue') {
                    filter._fcmValue = (new Date(filter._fcmValue)).valueOf();
                    filter._fcmPath += '.__fcmMockupDate.value';
                }
            }
            dataCollection = dataCollection.filter((a) => {
                for (const filter of query._query.filters || []) {
                    filter._fcmValue;
                    filter._fcmPath;
                    const value = _.get(a.doc, filter._fcmPath);
                    if (value === undefined) { // Simular comportamento de busca usando índice
                        return false;
                    }
                    // '<' | '<=' | '==' | '!=' | '>=' | '>' | 'array-contains' | 'in' | 'array-contains-any' | 'not-in'
                    switch (filter.op) {
                        case '<':
                            if (value >= filter._fcmValue) {
                                return false;
                            }
                            break;
                        case '<=':
                            if (value > filter._fcmValue) {
                                return false;
                            }
                            break;
                        case '==':
                            if (value !== filter._fcmValue) {
                                return false;
                            }
                            break;
                        case '!=':
                            if (value === filter._fcmValue) {
                                return false;
                            }
                            break;
                        case '>=':
                            if (value < filter._fcmValue) {
                                return false;
                            }
                            break;
                        case '>':
                            if (value <= filter._fcmValue) {
                                return false;
                            }
                            break;
                        case 'array-contains':
                            if (!Array.isArray(value) || !value.includes(filter._fcmValue)) {
                                return false;
                            }
                            break;
                        case 'in':
                            if (!Array.isArray(filter._fcmValue) || !filter._fcmValue.includes(value)) {
                                return false;
                            }
                            break;
                        case 'not-in':
                            if (Array.isArray(filter._fcmValue) && filter._fcmValue.includes(value)) {
                                return false;
                            }
                            break;
                        case 'array-contains-any':
                            if (!Array.isArray(filter._fcmValue) || !Array.isArray(value) || !filter._fcmValue.some((a) => value.includes(a))) {
                                return false;
                            }
                            break;
                    }
                }
                return true;
            });
        }
        if (query._query.limit) {
            dataCollection = dataCollection.slice(0, query._query.limit);
        }
        return new QuerySnapshot(dataCollection, collection, this);
    }
    async addDoc(ref, value) {
        const path = this._getPath(ref);
        path.id = this._newId();
        this.dataObj[path.collection] ||= {};
        this.dataArray[path.collection] ||= [];
        const newValue = _.cloneDeep(value);
        this._setDoc(path, newValue, undefined, 'add');
        return this._getRef(path);
    }
    async setDoc(ref, value, options) {
        const path = this._getPath(ref);
        this.dataObj[path.collection] ||= {};
        this.dataArray[path.collection] ||= [];
        let newValue = _.cloneDeep(value);
        const oldItem = this.dataObj[path.collection][path.id];
        if (options?.merge && oldItem) {
            newValue = _.defaultsDeep(newValue, oldItem.doc);
        }
        this._setDoc(path, newValue, oldItem, 'set');
    }
    async getDoc(ref) {
        const path = this._getPath(ref);
        const doc = this.dataObj[path.collection]?.[path.id];
        return new DocumentSnapshot(doc, ref);
    }
    async updateDoc(ref, value, options) {
        const path = this._getPath(ref);
        this.dataObj[path.collection] ||= {};
        this.dataArray[path.collection] ||= [];
        let newValue = _.cloneDeep(value);
        const oldItem = this.dataObj[path.collection][path.id];
        newValue = _.defaultsDeep(newValue, oldItem?.doc);
        this._setDoc(path, newValue, oldItem, 'update');
    }
    async deleteDoc(ref) {
        console.log('ref', ref);
        const path = this._getPath(ref);
        this.dataObj[path.collection] ||= {};
        this.dataArray[path.collection] ||= [];
        delete this.dataObj[path.collection][path.id];
        const index = this.dataArray[path.collection].findIndex((a) => a.id === path.id);
        if (index >= 0) {
            this.dataArray[path.collection].splice(index, 1);
        }
    }
    async getCountFromServer(ref) {
        console.warn('TODO getCountFromServer', ref);
    }
    async getAggregateFromServer(ref, aggregate) {
        console.warn('TODO getAggregateFromServer', ref, aggregate);
    }
    async onSnapshot(ref, ...args) {
        console.warn('TODO onSnapshot', ref, args);
    }
}
let fcmFirestoreMockup = undefined;
export function getInstanceFcmFirestoreMockup(firestore) {
    if (!fcmFirestoreMockup) {
        fcmFirestoreMockup = new FcmFirestoreMockup(firestore);
    }
    return fcmFirestoreMockup;
}
